// A persistent, decorative dust field across the journey and its unfolding worlds.
const root = document.querySelector('[data-wonder]');
if (root) {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const layers = new Set();
  function mount(host, count) {
    if (host.querySelector(':scope > .w-enchanted-dust')) return;
    const layer = document.createElement('div');
    layer.className = 'w-enchanted-dust';
    layer.setAttribute('aria-hidden', 'true');
    const fragment = document.createDocumentFragment();
    for (let i = 0; i < count; i++) {
      const mote = document.createElement('span');
      mote.className = 'w-dust-mote';
      const depth = i % 11;
      const size = depth === 0 ? 14 : depth < 3 ? 6 : depth < 6 ? 2.7 : 1.2;
      const x = (i * 61.803 + 8.3) % 100;
      const y = (i * 43.719 + 13.7) % 100;
      mote.dataset.x = x;
      mote.dataset.y = y;
      mote.style.cssText = `--dust-x:${x}%;--dust-y:${y}%;--dust-size:${size}px;--dust-blur:${size > 10 ? 4 : size > 4 ? 1.5 : .1}px;--dust-alpha:${size > 10 ? .13 : size > 4 ? .22 : .38 + (i % 4) * .09};--dust-speed:${18 + i % 13 * 2}s;--dust-delay:-${i * 2.73}s;--dust-travel:${i % 2 ? -42 : 53}px`;
      mote.appendChild(document.createElement('i'));
      fragment.appendChild(mote);
    }
    layer.appendChild(fragment);
    host.appendChild(layer);
    layers.add(layer);
  }
  function refresh() {
    for (const layer of layers) if (!layer.isConnected) layers.delete(layer);
    root.querySelectorAll('.w-world-dialog').forEach(dialog => mount(dialog, 36));
  }
  mount(root, innerWidth < 701 ? 58 : 94);
  refresh();
  new MutationObserver(refresh).observe(root.querySelector('.w-stage') || root, {childList:true, subtree:true});
  let frame = 0, point = null;
  document.addEventListener('pointermove', event => {
    if (reduced.matches || !fine.matches) return;
    point = {x:event.clientX, y:event.clientY};
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      for (const layer of layers) {
        if (layer.closest('dialog') && !layer.closest('dialog').open) continue;
        const box = layer.getBoundingClientRect();
        for (const mote of layer.children) {
          const dx = box.left + box.width * Number(mote.dataset.x) / 100 - point.x;
          const dy = box.top + box.height * Number(mote.dataset.y) / 100 - point.y;
          const distance = Math.hypot(dx, dy);
          const force = Math.max(0, 1 - distance / 185) * 82;
          mote.style.setProperty('--repel-x', `${distance ? dx / distance * force : force}px`);
          mote.style.setProperty('--repel-y', `${distance ? dy / distance * force : 0}px`);
        }
      }
    });
  }, {passive:true});
  document.documentElement.addEventListener('pointerleave', () => {
    for (const layer of layers) for (const mote of layer.children) {
      mote.style.removeProperty('--repel-x');
      mote.style.removeProperty('--repel-y');
    }
  });
}
